import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@mantine/core/styles.css';
import { Auth0Provider } from '@auth0/auth0-react';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENTID;
const redirectUri= window.location.origin + '/Home';
const audience= process.env.REACT_APP_AUTH0_AUDIENCE; 
//const audience='http:suci-back-test-endpoint';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Auth0Provider 
      domain={domain}
      clientId={clientId}      
      authorizationParams={{ redirect_uri: redirectUri, audience:audience }}      
      >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
